import React, { useState, Children } from 'react';

import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import api from '../../_helpers/api';
import { IconButton, ButtonToolbar, Divider, Whisper, Tooltip } from 'rsuite';
import { Row, Col, Placeholder, Stack } from 'rsuite';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import TagUnauthorizeIcon from '@rsuite/icons/TagUnauthorize';
import EmailIcon from '@rsuite/icons/Email';
import { JSONTree } from 'react-json-tree';
import { Card } from 'Components/Common/Card/Card';
import { theme } from 'Components/Common/JSONTreeTheme';
import { downloadFile } from 'Components/_helpers/utils';
import SendMailModal from 'Components/Common/SendMail/SendMailModal';
import CopyIcon from '@rsuite/icons/Copy';
import InvalidationModal from '../Invalidation/InvalidationModal';
import { Invalidation } from 'Components/Common/Detail/Invalidation';
import { RecepcionMH } from './RecepcionMH';

export const Detail = (props) => {
  const { dteType, title, dte, loading, onRefresh } = props;

  const [openSendMailModal, setOpenSendMailModal] = useState(false);
  const [openInvalidationModal, setOpenInvalidationModal] = useState(false);

  const exportJson = () => {
    downloadFile(
      `${api.getUri()}${dteType}/Json?codigoGeneracion=${dte.dte.identificacion.codigoGeneracion}`,
      `${dte.dte.identificacion.codigoGeneracion}.json`
    );
  };

  const exportPdf = () => {};

  const exportZip = () => {
    downloadFile(
      `${api.getUri()}${dteType}/Zip?codigoGeneracion=${dte.dte.identificacion.codigoGeneracion}`,
      `${dte.dte.identificacion.codigoGeneracion}.zip`
    );
  };

  const sendMail = () => {
    setOpenSendMailModal(true);
  };

  const invalidateDTE = () => {
    setOpenInvalidationModal(true);
  };

  const onInvalidation = () => {
    setOpenInvalidationModal(false);
    onRefresh();
  };

  const isDarkSchemePrefered = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <Stack spacing={6}>
            <h4>{title}</h4>
            <Whisper trigger="hover" placement={'auto'} speaker={<Tooltip>Copiar código de generación</Tooltip>}>
              <IconButton
                icon={<CopyIcon />}
                size="sm"
                onClick={() => {
                  navigator.clipboard.writeText(dte.dte.identificacion.codigoGeneracion);
                }}
              />
            </Whisper>
          </Stack>
        </div>
      }
    >
      {loading ? (
        <Placeholder.Paragraph style={{ marginTop: 30 }} rows={8} graph="image" active />
      ) : (
        <div>
          <SendMailModal
            isOpen={openSendMailModal}
            setOpen={setOpenSendMailModal}
            dteType={dteType}
            codigoGeneracion={dte.dte.identificacion.codigoGeneracion}
          />
          <InvalidationModal
            isOpen={openInvalidationModal}
            setOpen={setOpenInvalidationModal}
            emisor={dte.dte.emisor}
            dteType={dteType}
            codigoGeneracion={dte.dte.identificacion.codigoGeneracion}
            correoReceptor={props.correoReceptor || dte.dte.receptor?.correo}
            onInvalidation={onInvalidation}
          />
          <ButtonToolbar>
            <IconButton onClick={exportJson} appearance="primary" icon={<FileDownloadIcon />}>
              Exportar json
            </IconButton>
            {dte.recepcion.estado === 'PROCESADO' && (
              <>
                <IconButton onClick={exportPdf} disabled appearance="primary" icon={<FileDownloadIcon />}>
                  Exportar pdf
                </IconButton>
                <IconButton onClick={exportZip} appearance="primary" icon={<FileDownloadIcon />}>
                  {'Exportar .zip (json + pdf)'}
                </IconButton>
                {dte.estatus.estatusVigencia === 1 && (
                  <>
                    <IconButton onClick={sendMail} appearance="primary" icon={<EmailIcon />}>
                      Enviar por correo
                    </IconButton>
                    <IconButton onClick={invalidateDTE} appearance="primary" color="red" icon={<TagUnauthorizeIcon />}>
                      Invalidar DTE
                    </IconButton>
                  </>
                )}
              </>
            )}
          </ButtonToolbar>
          <Divider>Detalles del DTE</Divider>
          <Row>
            {Children.map(props.children, (child) => (
              <Col lg={8} md={24} style={{ padding: 10 }}>
                {child}
              </Col>
            ))}
            <Col lg={8} md={24} style={{ padding: 10 }}>
              {dte.estatus.estatusVigencia === 3 ? (
                <Invalidation codigoGeneracion={dte.dte.identificacion.codigoGeneracion} dteType={dteType}/>
              ) : (
                <RecepcionMH recepcion={dte.recepcion} codigoGeneracion={dte.dte.identificacion.codigoGeneracion} estatus={dte.estatus} />
              )}
            </Col>
            <Col lg={8} md={24} style={{ padding: 10 }}>
              <Card header={'Representación de  la estructura del DTE'}>
                <JSONTree theme={theme} data={dte.dte} invertTheme={isDarkSchemePrefered} />
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </SectionPanel>
  );
};
